import React from 'react';
import { ApplicationView, useController } from '@aha-app/mvc';
import FieldsController from '../../../controllers/FieldsController';
import EditField from './EditField';
import DrawerContents from '../DrawerContents';
import AttributeTable from '../attributes/AttributeTable';

const EditFields = () => {
  const controller = useController(FieldsController);
  const { fields } = controller.state;

  return (
    <DrawerContents titleHTML='Manage fields'>
      <aha-alert type='info'>
        <strong>You are editing fields for this whiteboard.</strong> Changes you
        make here apply to the whole whiteboard.
      </aha-alert>
      <AttributeTable noTitle>
        {fields.map(field => (
          <EditField key={field.id} field={field} />
        ))}
      </AttributeTable>
    </DrawerContents>
  );
};

export default ApplicationView(EditFields);
